import { Box, Typography } from "@material-ui/core";
import CheckIcon from "@mui/icons-material/Check";
import themeColorsDesingSystem from "assets/theme/ds-colors";

const STEPS = [
  { key: 0, label: "Dados Gerais" },
  { key: 1, label: "Perfil" },
  { key: 2, label: "Acessos" },
];

function StepCircle({ index, label, active, completed }) {
  const isActive = active && !completed;
  const isCompleted = completed;

  const circleBg =
    isCompleted || isActive
      ? themeColorsDesingSystem.primary.main
      : themeColorsDesingSystem.stone.medium;

  const circleColor =
    isCompleted || isActive
      ? themeColorsDesingSystem.text.secondary
      : themeColorsDesingSystem.text.primary;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      flex={1}
      minWidth={0}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: circleBg,
          color: circleColor,
          fontWeight: 700,
          fontSize: "1rem",
        }}
      >
        {isCompleted ? (
          <CheckIcon sx={{ fontSize: 22, color: "#fff" }} />
        ) : (
          index + 1
        )}
      </Box>
      <Typography
        variant="caption"
        align="center"
        style={{
          marginTop: 8,
          fontWeight: isActive || isCompleted ? 600 : 400,
          color:
            isActive || isCompleted
              ? themeColorsDesingSystem.primary.main
              : themeColorsDesingSystem.gray.dark,
          maxWidth: 120,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}

export default function UserFormStepper({ currentStep = 0 }) {
  return (
    <Box
      display="flex"
      alignItems="flex-start"
      justifyContent="center"
      width="100%"
      maxWidth={720}
      mx="auto"
      py={2}
      px={1}
    >
      {STEPS.map((step, index) => {
        const completed = currentStep > step.key;
        const active = currentStep === step.key;
        const connectorDone = currentStep > step.key;

        return (
          <Box
            key={step.key}
            display="flex"
            alignItems="flex-start"
            flex={index < STEPS.length - 1 ? 1 : "0 0 auto"}
            minWidth={0}
          >
            <StepCircle
              index={step.key}
              label={step.label}
              active={active}
              completed={completed}
            />
            {index < STEPS.length - 1 && (
              <Box
                sx={{
                  flex: 1,
                  height: 3,
                  mt: "18px",
                  mx: 1,
                  borderRadius: 2,
                  backgroundColor: connectorDone
                    ? themeColorsDesingSystem.primary.main
                    : themeColorsDesingSystem.stone.main,
                }}
              />
            )}
          </Box>
        );
      })}
    </Box>
  );
}
